@if ((alertService.showPreviewBanner$ | async) && (awsOutageObj$ | async); as awsOutageObj) {
  <div id="alert-status-banner">
    <span [innerHtml]="previewText ?? awsOutageObj?.safeHtml"></span>
  </div>
}

<arpio-center-panel>
  <div>
    <h1 class="alert-header">Alerts</h1>
    <app-alerts-editor
      [awsOutageItem]="awsOutageObj$ | async"
      (previewTextChange)="onPreviewTextChange($event)"
      (showBanner)="onshowBannerChange($event)"
    >
    </app-alerts-editor>
  </div>
</arpio-center-panel>
